/* Native Staff Pick badges for cards rendered after the initial Liquid response. */
(function () {
  'use strict';
  var label = document.currentScript.dataset.label || 'Staff Pick';
  var cards = '[data-dw-staff-pick],.boost-sd__product-item,.boost-sd__suggestion-queries-item--product,.boost-sd__quick-view';
  var badgeClass = 'dw-staff-pick-badge';
  var pending = new Set();
  var frame = 0;
  var parsed = new WeakMap();

  function tagged(card) {
    if (card.hasAttribute('data-dw-staff-pick')) return card.dataset.dwStaffPick === 'true';
    var raw = card.getAttribute('data-product');
    if (!raw) return false;
    var cached = parsed.get(card);
    if (cached && cached.raw === raw) return cached.tagged;
    var selected = false;
    try {
      var tags = JSON.parse(raw).tags;
      if (typeof tags === 'string') tags = tags.split(',').map(function (tag) { return tag.trim(); });
      selected = Array.isArray(tags) && tags.indexOf('Staff pick') !== -1;
    } catch (_) { /* An incomplete card will be reconsidered when data-product changes. */ }
    parsed.set(card, { raw: raw, tagged: selected });
    return selected;
  }

  function sync(card) {
    if (!card.isConnected) return;
    var selected = tagged(card);
    var badges = Array.from(card.querySelectorAll('.' + badgeClass)).filter(function (badge) {
      return badge.closest(cards) === card;
    });
    if (!selected) { badges.forEach(function (badge) { badge.remove(); }); return; }
    // Liquid galleries have one badge per image; dynamic cards have one per main image host.
    if (card.hasAttribute('data-dw-staff-pick')) return;
    var host = card.querySelector('.boost-sd__product-image,.boost-sd__suggestion-queries-item-image');
    if (!host) return;
    if (!host.classList.contains('dw-staff-pick-host')) host.classList.add('dw-staff-pick-host');
    var kept = false;
    badges.forEach(function (badge) {
      if (badge.parentElement === host && !kept) kept = true;
      else badge.remove();
    });
    if (!kept) {
      var badge = document.createElement('span');
      badge.className = badgeClass;
      badge.textContent = label;
      host.appendChild(badge);
    }
  }

  function collect(node, descendants) {
    if (node.nodeType !== 1 || node.closest('.' + badgeClass)) return;
    var card = node.closest(cards);
    if (card) pending.add(card);
    if (descendants !== false) node.querySelectorAll(cards).forEach(function (child) { pending.add(child); });
  }

  function flush() {
    frame = 0;
    pending.forEach(sync);
    pending.clear();
  }

  document.querySelectorAll(cards).forEach(sync);
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      if (record.type === 'attributes') collect(record.target, false);
      else {
        // Ignore our own badge insertion/removal to avoid a mutation feedback loop.
        var changed = Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(function (node) {
          return node.nodeType === 1 && !node.classList.contains(badgeClass);
        });
        if (changed) {
          collect(record.target, false);
          record.addedNodes.forEach(function (node) { collect(node, true); });
        }
      }
    });
    if (pending.size && !frame) frame = requestAnimationFrame(flush);
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-product', 'data-dw-staff-pick'] });
}());
